import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

import StackCard from '../component/StackCard'
import Header from '../component/Header'
import Footer from '../component/Footer'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Achivment from "../component/Achivment";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const tabsData = [
    {
        id: 1,
        title: "Overview",
        content:
            "This is overview content. Add company details, fintech services or any introduction here.",
    },
    {
        id: 2,
        title: "Services",
        content:
            "This section contains your services like loan APIs, AI agents, payment gateway, fintech solutions.",
    },
    {
        id: 3,
        title: "Industries",
        content:
            "Industries we serve including fintech, banking, insurance, healthcare and enterprise.",
    },
    {
        id: 4,
        title: "Contact",
        content:
            "You can show contact details, email, phone number and support information.",
    },
];

export default function DebtFunding() {
    const points = [
        "Term Loans",
        "Working Capital Limits",
        "Project Finance",
        "Equipment Finance",
        "Construction Finance",
        "Capital Market Debt",
    ];
    const points2 = [
        "Non-Convertible Debentures",
        "Listed Bonds",
        "Commercial Papers",
        "Perpetual Bonds",
        "Masala Bonds",
        "Trade Finance",
    ];
    const points3 = [
        "Letter of Credit (LC)",
        "Bank Guarantee (BG)",
        "SBLC",
        "Buyers Credit",
        "Suppliers Credit",
        "Structured Debt",
    ];
    const points4 = [
        "Mezzanine Debt",
        "Bridge Funding",
        "Promoter Funding",
        "Inventory Funding",
        "Special Situation Finance",

    ];

  


    return (
        <div>
            <Header />
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-900  pt-36 pb-10 px-4 sm:px-6 lg:px-8">

                <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-[120px]" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-[140px] rounded-full" />
                <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,.15)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.15)_1px,transparent_1px)] bg-[size:40px_40px]" />

                <div className="max-w-7xl mx-auto relative z-10">
                    {/* Breadcrumb */}
                    <div className="flex items-center  flex-wrap gap-2 text-sm text-white/70 mb-6">Home
                        <KeyboardArrowRightIcon className="w-4 h-4" />
                        <span className="text-cyan-300">
                            Expertise
                        </span>
                    </div>
                    <div className='max-w-6xl'>
                        <h1 className="text-3xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-5">
                            Expertise:{" "}
                            <span className="text-dark-gold">
                                Debt Funding
                            </span>

                        </h1>

                        {/* Description */}
                        <p className=" text-white/70 text-lg sm:text-base lg:text-2xl leading-relaxed mb-8">
                            Comprehensive debt financing solutions designed to support business expansion, working capital management, project execution, and long-term capital requirements.
                        </p>





                    </div>
                </div>

                {/* section one */}
                <section className="py-20 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div>


                            </div>

                            {/* Right Points */}
                            <div className="space-y-5">
                                <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium">
                                    Banking Loan
                                </span>

                                <p className="text-2xl md:text-3xl text-white leading-tight mb-6">
                                    Traditional banking and NBFC funding solutions for operational and growth requirements.
                                </p>
                                <div className="grid grid-cols-3 gap-4 ">
                                    {points.map((point, index) => (
                                        <div
                                            key={index}
                                            className=" gap-4 bg-white/10 backdrop-blur-xl border border-white/10 rounded-xl py-5 px-4 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
                                        >


                                            <div>
                                                <h4 className="text-sm  text-white pt-3">
                                                    {point}
                                                </h4>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* end */}

                {/* section two */}
                <section className="py-10 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div>
                                <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium mb-5">
                                    Capital Market Debt
                                </span>
                                <p className="text-2xl md:text-3xl  text-white leading-tight mb-6">
                                    Debt capital market instruments for large-scale and institutional fundraising requirements.
                                </p>
                                <ul>
                                    {points2.map((point, index) => (
                                        <li key={index} className="flex gap-3 mb-3">
                                            <div className="w-10 h-10 shrink-0 rounded-lg bg-cyan-500/20 flex items-center justify-center"> <KeyboardArrowRightIcon className="text-white" /> </div>
                                            <div>
                                                <h4 className="text-lg  text-white">
                                                    {point}
                                                </h4>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Right Points */}
                            <div className="space-y-5"></div>

                        </div>
                    </div>
                </section>
                {/* end */}

                {/* three start */}
                <section className="py-10 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div className="">


                            </div>

                            {/* Right Points */}
                            <div className="space-y-5 " >
                                <div className="space-y-5 border-1">
                                    <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium ">
                                        Trade Finance
                                    </span>

                                    <p className="text-2xl md:text-3xl  text-white leading-tight mb-6">
                                        Short-term structured solutions facilitating domestic and international trade transactions.
                                    </p>
                                    <div className="grid grid-cols-3 gap-4 ">
                                        {points3.map((point, index) => (
                                            <div
                                                key={index}
                                                className=" gap-4 bg-white/10 backdrop-blur-xl border border-white/10 rounded-xl py-5 px-4 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
                                            >


                                                <div>
                                                    <h4 className="text-sm  text-white pt-3">
                                                        {point}
                                                    </h4>

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* end */}

                {/* four start */}
                <section className="py-10 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div className="">

                                <div className="space-y-5 border-1">
                                    <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium">
                                        Structured Debt
                                    </span>

                                    <p className="text-2xl md:text-3xl  text-white leading-tight mb-6">
                                        Customized debt structures designed for complex funding and cash flow-based transactions.
                                    </p>
                                    <ul>
                                        {points4.map((point, index) => (
                                            <li key={index} className="flex gap-3 mb-3">
                                                <div className="w-10 h-10 shrink-0 rounded-lg bg-cyan-500/20 flex items-center justify-center"> <KeyboardArrowRightIcon className="text-white" /> </div>
                                                <div>
                                                    <h4 className="text-lg  text-white">
                                                        {point}
                                                    </h4>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            {/* Right Points */}
                            <div className="space-y-5 " >

                            </div>

                        </div>
                    </div>
                </section>
                {/* end */}

            </section>

           


            <Achivment />
            <Footer />
        </div>
    )
}



